import React from "react";
import { useTranslation } from "react-i18next";
import { Caption1 } from "@activecollab/components";
import PropTypes from "prop-types";
import { FormatLocalDate } from "~/components/Formatters";
import UserLink from "~/components/UserLink/UserLink";
export const Metadata = ({ calendarName, createdOn, createdByName, createdById, createdByEmail }) => {
  const { t } = useTranslation();
  return (
    <div
      className="tw-flex tw-flex-row tw-gap-2 tw-min-h-4 tw-flex-wrap tw-justify-center tw-max-w-full"
      data-testid="calendar-metadata"
    >
      <Caption1
        color="secondary"
        className="tw-max-w-full tw-truncate"
      >
        {calendarName}
      </Caption1>
      <Caption1 color="secondary">|</Caption1>
      <Caption1 color="secondary">
        {t("Created by")}{" "}
        <UserLink
          id={createdById}
          hideAvatar
          renderAs={Caption1}
          email={createdByEmail}
          nameProps={{
            color: "secondary",
          }}
          name={createdByName}
          context="event - created-by"
        />{" "}
        {t("on")}{" "}
        {createdOn ? (
          <FormatLocalDate
            value={createdOn}
            long={false}
          />
        ) : null}
      </Caption1>
    </div>
  );
};

Metadata.propTypes = {
  calendarName: PropTypes.string,
  createdOn: PropTypes.number,
  createdByName: PropTypes.string,
  createdById: PropTypes.number,
  createdByEmail: PropTypes.string,
};
